import { useEffect, useRef, type ReactNode } from 'react'
import { TableAudio } from '@v2/table'
import { Icon, interfaceSoundEvents } from '@v2/react'

export function Page({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  const audio = useRef<TableAudio | null>(null)
  useEffect(() => {
    const device = new TableAudio()
    audio.current = device
    return () => { device.dispose(); audio.current = null }
  }, [])
  return <div {...interfaceSoundEvents(sound => audio.current?.interaction(sound))}
    onPointerDownCapture={event => { if (event.isTrusted) void audio.current?.unlock() }}
    onKeyDownCapture={event => { if (event.isTrusted) void audio.current?.unlock() }}
    className={`pg${wide ? ' is-wide' : ''}`}><main className="pg-main">{children}</main></div>
}
export function Wordmark() {
  return <a className="pg-wordmark" href="/" aria-label="Tabletop with Friends home"><Icon name="leaf" size={18}/><span>Tabletop with Friends</span></a>
}
export function timeAgo(timestamp: number): string {
  const minutes = Math.max(0, Math.round((Date.now() - timestamp) / 60_000))
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  return days === 1 ? 'yesterday' : `${days}d ago`
}
